import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface InboxSummary {
  totalUnread: number;
  unreadByAssignee: Array<{
    assignedToId: string | null;
    unreadCount: number;
    conversationCount: number;
  }>;
}

export function useInboxSummary(enabled = true) {
  return useQuery<InboxSummary>({
    queryKey: ['inbox-summary'],
    queryFn: async () => {
      const { data } = await api.get('/inbox/summary');
      return data;
    },
    enabled,
    staleTime: 30_000,
  });
}
